import LocomotiveScroll from 'locomotive-scroll';
import gsap from 'gsap';
import common from '../common';

let mainScroll;

class MainController {
	init() {
		mainScroll = new LocomotiveScroll({
			el: document.getElementById('js-scroll'),
			smooth: false,
			getSpeed: true,
			getDirection: true,
		});

		mainScroll.on('call', (value, way, obj) => {
			switch (value) {
				case 'scaleOut': {
					let picture = obj.el.getElementsByClassName('scale-out')[0];
					gsap.to(picture, {
						duration: 1.2,
						scale: 1,
						ease: 'power4.out',
					});
					break;
				}

				// SVG Circles
				case 'bubbles': {
					let tl = gsap.timeline(),
						bubbles = document.getElementsByClassName('bubble-item'),
						bubblesWithText = document.getElementsByClassName('bubble-item-text');

					tl.to(bubbles, {
						duration: 1.5,
						ease: 'expo.out',
						autoAlpha: 1,
						scale: 1,
						transformOrigin: '50% 50%',
						stagger: 0.05,
					}).to(bubblesWithText, {
						duration: 3,
						ease: 'expo.out',
						autoAlpha: 1,
						scale: 1,
						transformOrigin: '50% 50%',
						stagger: 0.05,
						delay: -1,
					});
					break;
				}

				case 'staggerShow': {
					let elements = obj.el.getElementsByClassName('js-hide');

					// TODO: Try to implement splittext
					gsap.to(elements, {
						duration: 1.2,
						y: 0,
						autoAlpha: 1,
						ease: 'power4.out',
						stagger: 0.05,
					});

					break;
				}

				default:
					break;
			}
		});

		common();
	}

	updateScroll() {
		mainScroll.update();
	}

	getScroll() {
		return mainScroll;
	}

	destroy() {
		mainScroll.destroy();
	}
}

export default MainController;



// WEBPACK FOOTER //
// ./scripts/highway/MainController.js